// tslint:disable:variable-name
import {NgxPermissionsService} from 'ngx-permissions';
import {Inject, Injectable, Injector} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {OauthModel} from '../shared/oauth.model';
import {CODE_LANG, IS_PORTUGAL, PORTUGAL_CODE} from '../../helpers/GlobalConstants';
import {environment} from '../../../environments/environment';
import {NavigationEnd} from '@angular/router';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class AuthService {
    private oauth: OauthModel;
    private uservo: any;
    public details: any = {uo: null};
    public listDelegation: any;
    public isDelegate: boolean = false;
    public totalInjectionPending:number = 0;
    public totalUnlock:number = 0;


  constructor(private injector: Injector, @Inject('config') private config: any,
                private permissionsService: NgxPermissionsService,
                public http: HttpClient) {
        this.oauth = config.oauth;
        if (localStorage.getItem(this.oauth.remoteUser)) {
            this.uservo = JSON.parse(localStorage.getItem(this.oauth.remoteUser));
        }
    }

  load() {
    if (!localStorage.getItem(this.oauth.remoteUser)) {
      const callbackUrl = location.origin;
      let secret = '';
      const secretFromSession = this.getFromSession(this.oauth.state);
      if (this.getParamsSearch('code')) {
        const code = this.getParamsSearch('code');
        secret = this.getParamsSearch('state');
        if (secret === secretFromSession) {
          this.getAccessToken(code).subscribe(user => {
            this.uservo = user;
            this.setPermission(this.getPermissionAuthorities(this.uservo, environment.clients, 'ROLE_NOT_ALLOWED'));
            window.history.replaceState(null, null, window.location.pathname);
          });
        }
      } else {
        secret = 'secret' + this.randomInt(0, 999999);
        this.saveInSession(this.oauth.state, secret);
        this.saveInSession('redirectTo', location.href);
        this.getAuthorizationUrl(secret, callbackUrl);
      }
    }
    this.uservo = JSON.parse(localStorage.getItem(this.oauth.remoteUser));
    if (this.uservo !== null) {
      let permissionAuthorities = this.getPermissionAuthorities(this.uservo, environment.clients, 'ROLE_NOT_ALLOWED');
      this.getDelegationHabPermission(this.uservo.userName).subscribe((response: any) => {
        if (response !== null) {
          this.listDelegation = response.listDelegation;
          permissionAuthorities = permissionAuthorities.concat(response.persmissions);
          this.countInjectionPending();
          this.isDelegate = this.listDelegation && this.listDelegation.length > 0;
          this.getNotifUnlock(response.listDelegation);
          console.log('permissionAuthorities {}', permissionAuthorities);
        }

        this.setPermission(permissionAuthorities);
      });

      console.log('permissionAuthorities {}', permissionAuthorities);

    }
  }

  public setPermission(array: any) {
    if(!localStorage.getItem("ROLE") || localStorage.getItem("ROLE") == 'null')
      this.permissionsService.loadPermissions(array);
    else if (localStorage.getItem("ROLE") == "ROLE_DEFAULT_MYSHIFT"){
      this.permissionsService.loadPermissions(array);
    }else {
      let permissions = localStorage.getItem("ROLE").split(",");
      this.permissionsService.loadPermissions(permissions);
    }
  }

  getDelegationHabPermission = username => {
    return this.http.post(environment.api.myshiftUrl + `/delegationHab/getPersmissionsAndDelegations`, {
      delegate: username
    });
  };

  getAccessToken(code): any {
    if (!this.hasValidAccessToken()) {
      return this.getAccessTokenRequest(code, () => {
        if (this.getFromSession('redirectTo')) {
          const sessionRedirectTo = this.getFromSession('redirectTo');
          localStorage.removeItem('redirectTo');
          location.href = sessionRedirectTo;
        } else if (this.oauth.useHash) {
          location.href = location.origin + '#/';
        }
      });
    }
  }

    hasValidAccessToken() {
        return this.getFromSession('access_token') !== null;
    }

    getAccessTokenRequest(code, callback?): any {
        const headers = new HttpHeaders({
            Authorization: 'Basic ' + this.encodeCredentials(this.oauth.client_id,
                this.oauth.secret),
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        const body = 'client_id=' + this.oauth.client_id
            + '&grant_type=authorization_code'
            + '&credentials=true'
            + '&code=' + code
            + '&client_secret=' + this.oauth.secret
            + '&scope=' + this.oauth.scope
            + '&redirect_uri=' + location.origin;


        return this.http.post(this.oauth.token, body, {headers})
            .subscribe(async (response: any) => {
                    if (response.access_token) {
                        localStorage.setItem('myAppAccess', response.userProfile.sectret2FA);
                        localStorage.setItem(this.oauth.remoteUser, JSON.stringify(response.userProfile));
                        localStorage.setItem('expires_in', btoa((new Date().getTime() +
                          new Date(response.expires_in * 1000).getTime()).toString()));
                    }
                    if (response.userProfile && response.userProfile.countryCode === PORTUGAL_CODE) {
                      localStorage.setItem(IS_PORTUGAL, 'Y');
                    }
                    if (response.userProfile && response.userProfile.codeLang) {
                      localStorage.setItem(CODE_LANG,response.userProfile.codeLang);
                    }
                },
                error => {
                    localStorage.clear();
                    location.href = this.oauth.logOut;
                }, () => callback());
    }

    encodeCredentials(client_id, client_secret) {
        const credentials = client_id + ':' + client_secret;
        return btoa(credentials);
    }

    public getAuthorizationUrl(secret, callbackUrl) {
        const uri = this.oauth.authorize +
            '?response_type=' + this.oauth.response_type +
            '&client_id=' + this.oauth.client_id +
            '&scope=' + this.oauth.scope +
            '&state=' + secret +
            '&redirect_uri=' + (typeof callbackUrl === undefined ? location.origin : callbackUrl);
        if(this.oauth.basic.url.includes(location.pathname)  || this.oauth.basic.url.includes(location.hash) ||
            this.authTypeHas('basic')) {
            this.addPermission(this.oauth.basic.roles);
        } else  {
            window.location.href = uri;
        }
    }

    public flushPermissions() {
        this.permissionsService.flushPermissions();
    }

    public addPermission(array: string | string[]) {
        this.permissionsService.addPermission(array);
    }

    public getPermission() {
        return this.permissionsService.getPermissions();
    }

    public hasRole(ROLE: string) {
      const permissions: Array<string> = Object.keys(this.getPermission());
      return permissions.includes(ROLE);
    }

  public getHRBP(registrationNumber) {
    return this.http.get(environment.api.mscore + 'management/rh/' + registrationNumber);
  }

  public getDetailsUser(registrationNumber): any {
    return new Promise((r, j) => {
      this.http.get(environment.api.mscore + 'employee/usernameDetails/' + registrationNumber).subscribe(r, j)
    });
  }

    saveInSession(key, value): void {
        localStorage.setItem(key, value);
    }

    randomInt(min, max): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    getFromSession(key): any {
        return localStorage.getItem(key);
    }

    public getUser(key?: string) {
        const uservo = JSON.parse(localStorage.getItem(this.oauth.remoteUser));
        if (uservo) {
            if (typeof key === 'undefined') {
                return uservo;
            } else {
                return uservo[key];
            }
        }
    }

    public setUser(key: string, v: string) {
        const uservo = JSON.parse(localStorage.getItem(this.oauth.remoteUser));
        uservo[key] = v;
        localStorage.setItem(this.oauth.remoteUser, JSON.stringify(uservo));
    }

    public getCurrentUser(key?: string) {
        const user = JSON.parse(localStorage.getItem(this.oauth.remoteUser));
        return user[key];
    }

  public getPermissionAuthorities(user: any, keys: string[], except?: string) {
    const permissions: Array<string> = [];
    user.authorities.reduce((i, n, index, array ) => {
      if (keys.indexOf(n.clientId) > -1) {
        permissions.push(n.authority);
      }
    }, {});

    return (permissions.length > 0 ? permissions : [except]);
  }

    getParamsSearch(key?: string) {
        let search: any = window.location.search.substring(1);
        if (search !== null) {
            let e = {};
            search = search.split('&').map((n, i) => {
                let v = n.split('=');
                e[v[0]] = v[1];
                return e;
            });
            if (typeof key !== 'undefined') {
                return search[0][key];
            } else {
                return search[0];
            }
        }
        return;
    }
    hasConnected() {
        return JSON.parse(localStorage.getItem(this.oauth.remoteUser)) != null;
    }
    authTypeHas(type) {
        return this.getFromSession('authType') === type;
    }
    logout() {
        const hasBasic = this.authTypeHas('basic');
        window.localStorage.clear();
        this.flushPermissions();
        if(hasBasic) {
            localStorage.setItem('authType', 'basic');
            window.location.href = '#/login';
        } else {
            window.location.href = environment.oauth.logOut;
        }
    }

  totalInjectionsPending():Observable<any> {
    return this.http.post(environment.api.myshiftUrl +`/injection/v2/count`, this.listDelegation);
  }

  getNotifUnlock(listDelegation){
    this.getHRBPUnlockNotifs(listDelegation).subscribe(res=> this.totalUnlock = res.count)
  }
  public getHRBPUnlockNotifs(listDelegation?): Observable<any> {
    if (listDelegation)
      return this.http.post(environment.api.myshiftUrl+`/requestUnlocking/pending/v2/count`,listDelegation);

    return this.http.post(environment.api.myshiftUrl+`/requestUnlocking/pending/v2/count`,this.listDelegation?this.listDelegation:[]);
  }

  public countInjectionPending() {
    this.totalInjectionsPending()
      .subscribe(total=>this.totalInjectionPending = total);
  }

  // Check that TL type is PROD or Hors PROD
  checkTlIsProd(){
    if (this.hasRole("ROLE_TL_MYSHIFT2")){
      let detailsUser = JSON.parse(localStorage.getItem("DETAILS"));
      return detailsUser && detailsUser.staffType? detailsUser.staffType.toUpperCase() == "P": false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/auth.service.ts